import { createV3Queries } from "@query/utils/createV3Queries";
import { workLoggingConfigsApi } from "@api";

export const queriesWorkLoggingConfigs = createV3Queries(
  "workLoggingConfigsApi",
  workLoggingConfigsApi
);
